import { useState, useEffect } from 'react';
import { fetchContent } from '../../services/parameter.service';

const useContentModeradora = () => {
  const [contentModeradora, setContentModeradora] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getContentModeradora = async () => {
    setIsLoading(true);

    try {
      const responseContent = await fetchContent('moderadora');
      setContentModeradora(responseContent.data.list);

      setIsLoading(false);
    } catch (error) {
      console.error(' ERROR EN useContentModeradora --> ', error);
    }
  };

  useEffect(() => {
    getContentModeradora();
  }, []);

  return {
    contentModeradora,
  };
};

export default useContentModeradora;
